import { Box, type ChakraProps, Flex, SimpleGrid, type SimpleGridProps } from "@chakra-ui/react"
import React from "react"
import { pageContentWidth } from "../common/commonConstants"
import { AnimatePresence, motion } from "framer-motion"

interface SubPageProps {
  children: React.ReactNode
  props?: Record<string, string>
}
export const SubPage = ({ children, props }: SubPageProps): JSX.Element => (
  <AnimatePresence>
    <motion.div exit={{ opacity: 0 }} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <Box px={0} {...props} mb="80px">
        {children}
      </Box>
    </motion.div>
  </AnimatePresence>
)

interface SubPageContentProps {
  children: React.ReactNode
  props?: ChakraProps
  pageContentWidthOverride?: string
  innerBoxProps?: ChakraProps
}
export const SubPageContent = ({ children, props, pageContentWidthOverride, innerBoxProps }: SubPageContentProps): JSX.Element => (
  <Flex justify="center" pt={[4, 4, 4, 8]} {...props}>
    <Box
      px={4}
      w={["100%", "100%", "100%", pageContentWidthOverride ?? pageContentWidth, "90%", "85%"]}
      maxW="1500px"
      minHeight={["200px", "200px", "500px", "500px"]}
      {...innerBoxProps}
    >
      {children}
    </Box>
  </Flex>
)

interface SimpleGridPropsInterface {
  children: React.ReactNode
  props?: SimpleGridProps
}
export const SimpleGridWrapper = ({ children, props }: SimpleGridPropsInterface): JSX.Element => (
  <SimpleGrid columns={[2, 2, 2, 3, 3, 3]} spacing={["16px", "16px", "16px", "32px", "32px", "32px"]} {...props} align="center">
    {children}
  </SimpleGrid>
)
